import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const allServices = [
  {
    icon: '📱',
    title: 'Social Media Marketing',
    desc: 'Grow your brand across Facebook, Instagram & LinkedIn with targeted campaigns and creative content that converts followers into customers.',
    path: '/services/social-media-marketing',
    tag: 'Marketing',
  },
  {
    icon: '🔍',
    title: 'Social Media Optimization',
    desc: 'Optimize your profiles and content strategy to boost organic reach, improve discoverability, and build authentic brand presence.',
    path: '/services/social-media-optimization',
    tag: 'Optimization',
  },
  {
    icon: '💬',
    title: 'WhatsApp Marketing',
    desc: 'Reach thousands of customers instantly with personalized WhatsApp campaigns. 98% open rate — the most direct marketing channel.',
    path: '/services/whatsapp-marketing',
    tag: 'Marketing',
  },
  {
    icon: '🎯',
    title: 'Google Ads (PPC)',
    desc: 'Drive high-intent traffic to your business with expert Google Ads campaigns. Be at the top of Google when customers search for you.',
    path: '/services/google-ads',
    tag: 'Paid Ads',
  },
  {
    icon: '📊',
    title: 'Meta Ads',
    desc: 'Maximize ROI with data-driven Facebook and Instagram advertising. Reach your exact target audience and generate quality leads.',
    path: '/services/meta-ads',
    tag: 'Paid Ads',
  },
  {
    icon: '🎨',
    title: 'Website Design',
    desc: 'Stunning, conversion-focused website designs that capture your brand identity and turn visitors into customers.',
    path: '/services/website-design',
    tag: 'Design',
  },
  {
    icon: '🌐',
    title: 'Website Development',
    desc: 'High-performance, secure, and scalable websites built with modern technology and optimized for speed and SEO.',
    path: '/services/website-development',
    tag: 'Development',
  },
  {
    icon: '🔧',
    title: 'Website Maintenance',
    desc: 'Keep your website secure, fast, and up-to-date with our comprehensive maintenance plans. 99.9% uptime guaranteed.',
    path: '/services/website-maintenance',
    tag: 'Maintenance',
  },
  {
    icon: '🖥️',
    title: 'Domain & Hosting',
    desc: 'Get your business online with the right domain and reliable, high-speed hosting. Everything managed under one roof.',
    path: '/services/domain-hosting',
    tag: 'Hosting',
  },
  {
    icon: '🛒',
    title: 'E-Commerce Development',
    desc: 'Launch a powerful online store with seamless shopping experience, secure payments, and inventory management.',
    path: '/services/ecommerce-development',
    tag: 'Development',
  },
  {
    icon: '✏️',
    title: 'Graphic Design',
    desc: 'Professional logos, banners, social media creatives, and brand identity that makes your business stand out.',
    path: '/services/graphic-design',
    tag: 'Design',
  },
  {
    icon: '📈',
    title: 'SEO',
    desc: 'Rank higher on Google with our proven SEO strategies. Drive organic traffic and generate leads without paid ads.',
    path: '/services/seo',
    tag: 'SEO',
  },
];

export default function Services() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.animate-on-scroll, .service-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="home">

      {/* HERO */}
      <section className="page-hero">
        <div className="container page-hero-content hero-animate">
          <span className="section-tag">Everything You Need to Grow Online</span>
          <h1>Our <span>Services</span></h1>
          <p>From social media to website development, we offer a complete suite of digital marketing services to help your business grow online and generate consistent revenue.</p>
        </div>
      </section>

      {/* SERVICES GRID */}
      <section className="services-section" style={{ paddingTop: '70px' }}>
        <div className="container">
          <div className="services-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
            {allServices.map((service, i) => (
              <Link to={service.path} className="service-card" key={i} style={{ textDecoration: 'none' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                  <span className="sc-icon">{service.icon}</span>
                  <span style={{
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    letterSpacing: '1px',
                    textTransform: 'uppercase',
                    color: 'var(--logo-cyan)',
                    background: 'rgba(0,198,224,0.1)',
                    border: '1px solid rgba(0,198,224,0.2)',
                    padding: '3px 10px',
                    borderRadius: '20px',
                  }}>{service.tag}</span>
                </div>
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
                <span className="sc-arrow">→</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA BANNER */}
      <section className="cta-banner" style={{ marginTop: '60px' }}>
        <div className="cta-bg" />
        <div className="container">
          <div className="cta-content animate-on-scroll">
            <h2>Not Sure Which Service <span>You Need?</span></h2>
            <p>Book a free 30-minute consultation. We'll analyze your business and recommend the right digital strategy.</p>
            <div className="cta-actions">
              <Link to="/contact" className="btn-primary">Get Free Consultation →</Link>
              <a href="https://wa.me/919370115694" target="_blank" rel="noreferrer" className="btn-secondary">Chat on WhatsApp 💬</a>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
